"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentLocation = void 0;
var AppointmentLocation = /** @class */ (function () {
    function AppointmentLocation() {
        this.location = "";
    }
    return AppointmentLocation;
}());
exports.AppointmentLocation = AppointmentLocation;
//# sourceMappingURL=AppointmentLocation.js.map